/* eslint-disable */
import * as Types from '../../graphql/types.generated';

import { gql } from '@apollo/client';
export type AgentFiltersFragment = { __typename?: 'Agent', products?: Array<string | null> | null, insuranceCarrier?: Array<string | null> | null, certifications?: Array<string | null> | null, languages?: Array<string | null> | null };

export const AgentFiltersFragmentDoc = gql`
    fragment AgentFilters on Agent {
  products
  insuranceCarrier
  certifications
  languages
}
    `;